export default function ScreenThumb({ screen, onOpen, testid }) {
  return (
    <figure className="group">
      <button
        type="button"
        data-testid={testid}
        onClick={onOpen}
        aria-label={`${screen.caption} vergroten`}
        className="block w-full overflow-hidden rounded-2xl border border-[#2C2E29] bg-[#1C1D1A] transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#CAA362]/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#CAA362]"
      >
        <img
          src={screen.thumb}
          alt={screen.alt}
          width={360}
          height={782}
          loading="lazy"
          className="block h-auto w-full"
        />
      </button>
      <figcaption className="mt-3 flex flex-wrap items-center gap-2 text-sm text-[#B5B8B0]">
        <span>{screen.caption}</span>
        {screen.testVersion && (
          <span className="rounded-md border border-[#CAA362]/40 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#CAA362]">
            Testversie
          </span>
        )}
      </figcaption>
    </figure>
  );
}
